module.exports = __webpack_public_path__ + "assets/img/huhehaote.40694076.png";